import plainDriver from './driver'
import names from './names'
import withUsers from './withUsers'

let driver = plainDriver
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const withLogger = require('./withLogger').default
  driver = withLogger(driver)
}

const userDriver = withUsers()(driver)

export { driver, names, userDriver }
